module.exports = __webpack_public_path__ + "img/MHL.78ee58f2.svg";